import React from 'react';
import './FloatingNotesBackground.css';

const FloatingNotesBackground = () => {
  // Musical note symbols
  const noteSymbols = ['♪', '♫', '♬', '♩', '♭', '♯', '𝄞', '𝄢'];
  
  // Generate floating notes with random properties
  const notes = Array.from({ length: 25 }, (_, i) => {
    const isInitial = i < 12; // First 12 notes start on screen
    return {
      id: i,
      symbol: noteSymbols[Math.floor(Math.random() * noteSymbols.length)],
      left: Math.random() * 100, // Random horizontal position (0-100%)
      delay: isInitial ? 0 : Math.random() * 5, // No delay for initial notes
      duration: 8 + Math.random() * 4, // Random duration (8-12s)
      size: 20 + Math.random() * 30, // Random size (20-50px)
      opacity: 0.3 + Math.random() * 0.3, // Random opacity (0.3-0.6)
      initialPosition: isInitial ? Math.random() * 80 : -50, // First 8 notes start on screen, rest start below
      isInitial: isInitial
    };
  });

  return (
    <div className="floating-notes-background">
      {notes.map((note) => (
        <div
          key={note.id}
          className={`floating-note ${note.isInitial ? 'initial-note' : ''}`}
          style={{
            '--note-left': `${note.left}%`,
            '--animation-delay': `${note.delay}s`,
            '--animation-duration': `${note.duration}s`,
            '--note-size': `${note.size}px`,
            '--note-opacity': note.opacity,
            '--initial-bottom': `${note.initialPosition}%`
          }}
        >
          {note.symbol}
        </div>
      ))}
    </div>
  );
};

export default FloatingNotesBackground;

